import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SfaSalesLeadLabelListHdrContainerModel } from "../../../../../models/aggregates/sfa/SfaSalesLeadLabelListHdrContainer.model";
import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { Core2Config } from "../shared/core2Config";

@Injectable({
	providedIn: "root",
})
export class SfaSalesLeadLabelListHdrService extends BaseApiTemplateService<SfaSalesLeadLabelListHdrContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.SFA_MODULE_PREFIX +
		"sales-lead-label-list";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"sales-lead-label-list";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"sales-lead-label-list";
		this.httpClient = http;
	}
}
